export const customCategorySource = {
  beginDrag(props) {
    props.setDragging(true);
    return {
      id: props.id,
      index: props.index,
      position: props.position,
    };
  },

  endDrag(props, monitor) {
    props.setDragging(false);
    const didDrop = monitor.didDrop();
    if (didDrop) {
      props.saveCustomCategories();
    }
  },

  canDrag(props) {
    return props.canDrag;
  },
};

export const customCategoryTarget = {
  hover(props, monitor) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;

    const clientOffset = monitor.getClientOffset();

    const container = document.getElementsByClassName('main-content')[0];

    if (clientOffset.y < container.offsetTop + 50) {
      container.scrollBy(0, -5);
    }

    if (clientOffset.y > container.offsetTop + container.offsetHeight - 50) {
      container.scrollBy(0, 5);
    }

    if (dragIndex === hoverIndex) {
      return;
    }

    props.moveCustomCategory(dragIndex, hoverIndex);
  },
};
